var _circle, _circle2, _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#006FF5",
    fillOpacity: 0.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.4138,
    cy: 18.9274,
    r: 4.92737,
    stroke: "#006FF5",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_7237_2854",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9663 37.4998H13.7451C13.8658 31.467 18.794 26.6136 24.8557 26.6136C30.9174 26.6136 35.8456 31.467 35.9663 37.4998Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7451 37.4998L11.7455 37.4598L11.7047 39.4998H13.7451V37.4998ZM35.9663 37.4998V39.4998H38.0068L37.9659 37.4598L35.9663 37.4998ZM13.7451 39.4998H35.9663V35.4998H13.7451V39.4998ZM15.7447 37.5398C15.8437 32.5936 19.8852 28.6136 24.8557 28.6136V24.6136C17.7028 24.6136 11.888 30.3404 11.7455 37.4598L15.7447 37.5398ZM24.8557 28.6136C29.8263 28.6136 33.8678 32.5936 33.9667 37.5398L37.9659 37.4598C37.8235 30.3404 32.0086 24.6136 24.8557 24.6136V28.6136Z",
    fill: "#006FF5",
    mask: "url(#path-3-inside-1_7237_2854)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.033fecd4c57b2aee3733b86ff82dd336.svg";
export { ForwardRef as ReactComponent };